export default {
    getList: {
        default: [{
            id: 2018052400011,
            site_name: "玉环市第二人民医院",
            status: 1,
            name: "玉环市民卡开发商VPN权限临时调整",
            creater_name: "方建",
            server_type: 2,
            problem_type: 2,
            create_at: "2018-07-31 09:32:06",
            update_at: "2018-07-31 09:32:23"
        }, {
            id: 2018052400011,
            site_name: "天台县人力资源和社会保障局",
            status: 0,
            name: "玉环市民卡容灾方案",
            creater_name: "方建",
            server_type: 4,
            problem_type: 1,
            create_at: "2018-07-31 09:32:06",
            update_at: "2018-07-31 09:32:23"
        }, {
            id: 2018052400011,
            site_name: "玉环市第二人民医院",
            status: 0,
            name: "玉环市社会保险事业管理中心市局数据同步",
            creater_name: "方建",
            server_type: 2,
            problem_type: 6,
            create_at: "2018-07-31 09:32:06",
            update_at: "2018-07-31 09:32:23"
        }]
    }
}